import React from 'react'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { ComboBox } from './ComboBox'
import { CheckListBox } from './CheckListBox'
import { Row } from './Row'
import { ViewBox } from './ViewBox'
import { FieldLayoutSizes } from './FieldLayoutBox'
import { DateTimeBox } from './DateTimeBox'
import { TextBox } from './TextBox'
import { Button } from './Button'
import { FrequencyOccurrence, rruleWeekDays, EpisodeFrequency, FrequencyOccurrenceType } from 'common-tools/index'
import _ from 'lodash'
import moment from 'moment'

export class FrequencyBox extends React.Component {
  constructor (props) {
    super(props)

    this.state = {}
  }

  static propTypes = buildPropTypes([

  ], {
    skillOptions: pt.arrayOf(pt.object).isRequired,
    showFrequencyExplanation: pt.bool
  })

  componentDidUpdate () {

  }

  onGenerateFrequency () {
    const { ctrlData, startDate, untilDate } = this.props

    let parms = {
      freq: ctrlData.OccurrenceType,
      daysOfTheWeek: ctrlData.VisitDays,
      numberOfVisits: ctrlData.NumberOfVisits,
      count: this.onGetVisitCount(ctrlData),
      start: startDate,
      stop: untilDate
    }

    let result = EpisodeFrequency(parms)
    console.log(result)
    ctrlData.FrequencyText = result.ReadableText
    ctrlData.VisitCount = result.VisitDates.length
    ctrlData.VisitDates = result.VisitDates
    ctrlData.RuleString = result.String
  }

  onGetVisitCount (frequencyParms) {
    let count = 0

    switch (frequencyParms.OccurrenceType) {
      case 'DAILY':
        count = (_.parseInt(frequencyParms.NumberOfVisits) * 7) * _.parseInt(frequencyParms.NumberOfWeeks)
        break
      case 'WEEKLY':
        count = _.parseInt(frequencyParms.NumberOfVisits) * _.parseInt(frequencyParms.NumberOfWeeks)
        break
      case 'MONTHLY':
        count = _.parseInt(frequencyParms.NumberOfVisits)
        break
    }

    console.log({ frequencyParms, count })
    return count
  }

  onGetNumberOfWeeks () {
    const { ctrlData, startDate, untilDate } = this.props

    if (ctrlData) {
      ctrlData.NumberOfWeeks = _.round(
        moment.duration(
          moment.parseZone(untilDate)
            .diff(moment.parseZone(startDate))
        ).as('weeks')
      )
    }
  }

  render () {
    const { skillOptions, name, showFrequencyExplanation, ctrlData, startDate, untilDate } = this.props
    const { } = this.state

    this.onGetNumberOfWeeks()

    return (
      <React.Fragment>
        <Row>
          <ComboBox layout={FieldLayoutSizes.Three} name={`${name}.Skill`} label='Skill'
            options={_.concat([{ Text: 'Select a skill', Value: '' }], skillOptions || [])} />
          <ComboBox layout={FieldLayoutSizes.One} name={`${name}.NumberOfVisits`} label='Visits' readonly={!(ctrlData || '').Skill} options={FrequencyOccurrence} />
          <ComboBox layout={FieldLayoutSizes.Two} name={`${name}.OccurrenceType`} label='Occurrence' readonly={!(ctrlData || '').Skill}
            options={_.concat([{ Text: 'Select Occurrence Type', Value: '' }], FrequencyOccurrenceType)} />
          {(ctrlData || '').OccurrenceType !== 'MONTHLY'
            ? <TextBox layout={FieldLayoutSizes.One} name={`${name}.NumberOfWeeks`} label='Weeks' readonly />
            : null}
        </Row>
        {(ctrlData || '').OccurrenceType === 'DAILY'
          ? <Row>
            {(ctrlData || '').NumberOfVisits >= '1'
              ? <DateTimeBox layout={FieldLayoutSizes.Two} name={`TimeIn1`} label='First Time Slot' type='time' /> : null}
            {(ctrlData || '').NumberOfVisits >= '2'
              ? < DateTimeBox layout={FieldLayoutSizes.Two} name={`TimeIn2`} label='Second Time Slot' type='time' /> : null}
            {(ctrlData || '').NumberOfVisits >= '3'
              ? < DateTimeBox layout={FieldLayoutSizes.Two} name={`TimeIn3`} label='Third Time Slot' type='time' /> : null}
          </Row>
          : null}
        {(ctrlData || '').OccurrenceType !== 'DAILY'
          ? <Row>
            <CheckListBox layout={FieldLayoutSizes.Full} name={`${name}.VisitDays`} label='Visit Days' inline options={rruleWeekDays} />
          </Row>
          : null}
        <Row>
          <ViewBox layout={FieldLayoutSizes.Two} name={`${name}.VisitCount`} label='Visit Count' />
          {showFrequencyExplanation
            ? <ViewBox layout={FieldLayoutSizes.Six} name={`${name}.FrequencyText`} label='Frequency Description' />
            : null}
        </Row>
        <Row>
          <Button size='lg' color='primary' type='button' onClick={() => { this.onGenerateFrequency() }} >
            <span className='text-white'>Generate</span>
          </Button>
        </Row>
      </React.Fragment>
    )
  }
}
